import React from "react";
import SetupCheckList from "./setup/SetupCheckList";

const TestingScreen = () => {
  return <SetupCheckList />;
};

export default TestingScreen;
